import React, {Component} from 'react';
import Details from "../../../contentSecurityCenter/components/Details";
import $ from "jquery";

class Detail extends Details {
    // constructor(props) {
    //     super(props);
    // }

    componentDidMount() {
        if (this.urlParams && this.urlParams.checkUrl) {
            this.state.checkUrl = this.urlParams.checkUrl.check_info_url;
            if (this.state.checkUrl && this.state.checkUrl.indexOf('material') > -1) {
                this.state.dataType = 'material'
                this.getHistory(this.urlParams?.checkUrl?.id)
            }
        }
        super.componentDidMount()
    }

    render() {
        return super.render()
    }

    // 历史记录
    getHistory(editorId) {
        if (editorId) {
            let url = "/cm-sites-pms/website/news/getWebNewsHistory";
            let body = {webNewsId: editorId};
            this.request({
                url,
                body,
                callBack: (list) => {
                    if (list && list.length) {
                        this.setState({list});
                        this.setState({
                            mainBody: {
                                ...this.state.mainBody,
                                content: list.content,
                                title: list.title
                            },
                        });
                    }
                    this.getMaterial();
                }
            })
        }
    }
    //获取功微信公众号稿件数据
    getMaterial = () => {
        let checkUrl = this.state.checkUrl
        console.log(checkUrl)
        this.request({
            url: checkUrl,
            callBack: (res) => {
                console.log(res)
                let content = "";
                let title = "";
                let ftitle = "";
                let summary = "";
                let attach = [];
                let {index} = this.urlParams.checkAll;//第几页
                if (res && res.stuffList) {
                    let stuffList = res.stuffList[index]
                    content = stuffList.content;
                    title = stuffList.title;
                    summary = stuffList.summary
                    console.log(content, title, summary)
                    if (res.ftitle || res.stuffList.ftitle) {
                        ftitle = res.ftitle || res.stuffList.ftitle;
                    }
                }
                this.setState({
                    mainBody: {content, title, ftitle, summary},
                }, () => {
                    console.log(this.state.mainBody)
                })

            }
        })
    };


}

export default Detail;